module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group",
    style: ({
      width: _vm.inputWidth + 'px'
    })
  }, [(_vm.controls) ? _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.minDisabled
    },
    on: {
      "click": _vm.decrease
    }
  }, [_vm._v("-")])]) : _vm._e(), _vm._v(" "), _c('input', {
    ref: "input",
    staticClass: "form-control text-center",
    attrs: {
      "type": "text",
      "disabled": _vm.disabled,
      "max": _vm.max,
      "min": _vm.min
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "blur": function($event) {
        return _vm.handleBlur(_vm.value)
      },
      "input": function($event) {
        return _vm.setTempValue($event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.controls) ? _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.maxDisabled
    },
    on: {
      "click": _vm.increase
    }
  }, [_vm._v("+")])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7635835a","transformToRequire":{"audio":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/InputNumber.vue
// module id = 1574
// module chunks = 0